/**
 * The public site's origin: VITE_PUBLIC_SITE_URL when it is absolute, else
 * the console host without "app." (app.masar.om -> masar.om,
 * app.localhost:8088 -> localhost:8088).
 */
export function publicSiteOrigin(
  env: string | undefined,
  loc: Pick<Location, 'protocol' | 'hostname' | 'port'>,
): string {
  if (env && /^https?:\/\//.test(env)) return env.replace(/\/+$/, '');
  const host = loc.hostname.replace(/^app\./, '');
  return `${loc.protocol}//${host}${loc.port ? `:${loc.port}` : ''}`;
}
